import { render, staticRenderFns } from "./newsDig.vue?vue&type=template&id=7b09c686&scoped=true&"
import script from "./newsDig.vue?vue&type=script&lang=js&"
export * from "./newsDig.vue?vue&type=script&lang=js&"
import style0 from "./newsDig.vue?vue&type=style&index=0&id=7b09c686&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b09c686",
  null
  
)

export default component.exports